import React from 'react'
import ResultsList from './resultCard'
import ResultsListDesk from './resultsListDesk'
import InfoCard from './infoCard'
import useIsMobile from '../hooks/useIsMobile'

const DEFAULT_FIELDS = [
	{ label: 'Fecha de informe', key: 'fecha' },
	{ label: 'Número de orden', key: 'orden' },
	{ label: 'Clínica', key: 'clinica' },
	{ label: 'Informe', key: 'informe' }
]

const DataTable = ({
	loading,
	error,
	paginatedResults,
	hasActiveFilters,
	isCarousel = true,
    isHome = false,
	fields = DEFAULT_FIELDS,
	emptyTitle = 'No se encontraron resultados',
	emptySubtitle = 'Cuando tengas alguno, lo vas a ver acá.',
	showLabels = true
}) => {
	const isMobile = useIsMobile()
	if (loading && isHome) return <p>Cargando resultados...</p>
	if ((error || !paginatedResults || paginatedResults.length === 0) && isHome) {
		return <InfoCard title={emptyTitle} subtitle={emptySubtitle} />
	}
	return (
		<>
			<ResultsList
				isSearch={hasActiveFilters}
				results={paginatedResults}
				isCarousel={isCarousel}
				fields={fields}
				showLabels={showLabels}
				style={{ display: isMobile ? 'block' : 'none' }}
			/>
			<ResultsListDesk
				hasActiveFilters={hasActiveFilters}
				results={paginatedResults}
				headers={fields}
				style={{ display: isMobile ? 'none' : 'block' }}
			/>
		</>
	)
}

export default React.memo(DataTable)
